import { v4 as uuidV4 } from 'uuid'

export const uuid = () => uuidV4()

export const isBrowser = () => typeof window !== 'undefined'

// export const compareObjDeep: (obj1: KeyValue, obj2: KeyValue) => boolean = (obj1, obj2) => {

// }
